import * as actionTypes from '../../actionTypes';
import createReducer from '../../../../common/utils/createReducer';
import * as adminTypes from '../../../../common/actionTypes/adminTypes';
import get from 'lodash/get';
import * as translationTypes from '../../../../common/actionTypes/translationsActionTypes';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import updateImageDataOnPercentileChange from '../../../../self-onboarding-l2/src/photoCollection/utils/updateImageDataOnPercentileChange';

const INITIAL_STATE = {
  leads: [],
  coldLeads: [],
  onBoardedProperties: [],
  selectedLead: {},
  propertyDetailsMap: {},
  isLeadCardLoading: true,
  isOnboardedCardLoading: true,
  ewbProperties: [],
  checklistPageWidget: {},
  isAnyHotel: false,
  ewbAndRecontractProperties: [],
  latestUploadedImages: []
};

const reducer = {
  [adminTypes.SIGNOUT_USER_ON_AUTHENTICATION_FAIL]: (state, action) => INITIAL_STATE,
  [actionTypes.FETCH_SELECTED_LEAD_DETAILS]: (state, action) => {
    const { currentPropertyDetails } = action.payload;
    return {
      ...state,
      selectedLead: {
        ...currentPropertyDetails
      }
    };
  },
  [actionTypes.FETCH_PROPERTY_ONBOARD_CHECKLIST]: (state, action) => {
    const { propertyChecklist, propertyId } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[propertyId] || {};
    currentPropertyDetail['propertyChecklist'] = propertyChecklist;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [propertyId]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_PROPERTY_ONBOARDING_PROGRESS]: (state, action) => {
    const { completionPercentage, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['completionPercentage'] = completionPercentage;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_PROPERTY_AMENITIES]: (state, action) => {
    const { propertyAmenities, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['propertyAmenities'] = propertyAmenities;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_AMENITIES_WIDGET_DATA]: (state, action) => {
    const { data, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['propertyAmenitiesWidget'] = data;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.GET_ROOM_CATEGORIES]: (state, action) => {
    const { roomCategories, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['roomCategories'] = roomCategories;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.GET_ROOM_CATEGORIES_INFO]: (state, action) => {
    const { roomCategoriesInfo, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['roomCategoriesInfo'] = roomCategoriesInfo;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.GET_PROPERTY_DETAILS]: (state, action) => {
    const { cardData, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['basicInfo'] = cardData;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_TNC_DATA]: (state, action) => {
    const { tncData, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['termsOfServiceInfo'] = tncData;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_FINAL_CONTRACT]: (state, action) => {
    const { finalContractInfo, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['finalContractInfo'] = finalContractInfo;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_ROOM_COUNT_DETAILS]: (state, action) => {
    const { roomCountDetails, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['roomCountDetails'] = roomCountDetails;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.GET_KYC_DETAILS]: (state, action) => {
    const { kycDetails, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['kycDetails'] = kycDetails;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_LEAD_DATA]: (state, action) => {
    const { leadData, coldLeadData } = action.payload;
    return {
      ...state,
      leads: leadData,
      coldLeads: coldLeadData,
      isLeadCardLoading: false
    };
  },
  [actionTypes.SET_LEAD_LOADING_STATUS]: (state, action) => {
    const { isLeadCardLoading } = action.payload;
    return { ...state, isLeadCardLoading };
  },
  [actionTypes.SET_ONBOARDED_LOADING_STATUS]: (state, action) => {
    const { isOnboardedCardLoading } = action.payload;
    return { ...state, isOnboardedCardLoading };
  },
  [actionTypes.FETCH_ONBOARDED_DATA]: (state, action) => {
    const { onboardedData, ewbPropertiesData, isAnyHotel } = action.payload;
    return {
      ...state,
      onBoardedProperties: onboardedData,
      isOnboardedCardLoading: false,
      ewbProperties: ewbPropertiesData,
      isAnyHotel: isAnyHotel
    };
  },
  [actionTypes.SET_EWB_STATUS]: (state, action) => {
    const { ewbAndRecontractProperties } = action.payload;
    return {
      ...state,
      ewbAndRecontractProperties: ewbAndRecontractProperties
    };
  },
  [actionTypes.SET_LATEST_UPLOADED_IMAGES]: (state, action) => {
    const { latestUploadedImages } = action.payload;
    return {
      ...state,
      latestUploadedImages: [...state.latestUploadedImages, ...latestUploadedImages]
    };
  },
  [actionTypes.CLEAR_LATEST_UPLOADED_IMAGES]: (state, action) => {
    return {
      ...state,
      latestUploadedImages: []
    };
  },
  [actionTypes.GET_CHECKLIST_PAGE_WIDGET]: (state, action) => {
    const { data } = action.payload;
    return {
      ...state,
      checklistPageWidget: data
    };
  },
  [actionTypes.FETCH_IMAGES_CONFIG_SUCCESS]: (state, action) => {
    const { currentPropertyData, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          ...currentPropertyData
        }
      }
    };
  },
  [actionTypes.GET_SELECTED_IMAGES]: (state, action) => {
    const { images, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;

    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const imagesConfig = get(currentPropertyDetail, 'imagesConfig', {});
    let allImages = get(imagesConfig, 'allImages', []);
    allImages = [...allImages, ...images];

    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          imagesConfig: {
            ...imagesConfig,
            allImages: allImages
          }
        }
      }
    };
  },
  [actionTypes.UPDATE_IMAGES_STATUS]: (state, action) => {
    const { images, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;

    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const imagesConfig = get(currentPropertyDetail, 'imagesConfig', {});
    let allImages = get(imagesConfig, 'allImages', []);
    allImages = [...images];
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          imagesConfig: {
            ...imagesConfig,
            allImages: allImages
          }
        }
      }
    };
  },

  [translationTypes.CLEAR_REDUCERS]: (state, action) => INITIAL_STATE,
  [actionTypes.FETCH_PROPERTY_REVIEW_DETAILS]: (state, action) => {
    const { property_details, buckets, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['propertyReviewDetails'] = {
      property_details,
      buckets
    };
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.UPLOAD_IMAGE_SUCCESS]: (state, action) => {
    const { property_unique_id, currentPropertyData } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          ...currentPropertyData
        }
      }
    };
  },
  [actionTypes.DELETE_IMAGE_SUCCESS]: (state, action) => {
    const { property_unique_id, image_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const imagesConfig = get(currentPropertyDetail, 'imagesConfig', {});
    let images = cloneDeep(get(imagesConfig, 'allImages', []));

    for (const i in images) {
      if (images[i].id === image_id) {
        images[i].is_active = false;
        break;
      }
    }

    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          imagesConfig: {
            ...imagesConfig,
            allImages: images
          }
        }
      }
    };
  },
  [actionTypes.FETCH_PROPERTY_REVIEW_IMAGES]: (state, action) => {
    const { propertyImages, propertyRequirement, roomsImages, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['propertyReviewImages'] = { propertyImages, propertyRequirement, roomsImages };
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.SET_COVER_IMAGE]: (state, action) => {
    const { property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const requirements = get(currentPropertyDetail, 'imagesConfig.requirements', []);
    let highestPriorityRequirement = Number.MAX_SAFE_INTEGER;
    let coverUrl = '';
    for (const i in requirements) {
      if (requirements[i].priority < highestPriorityRequirement) {
        highestPriorityRequirement = requirements[i].priority;
        coverUrl = get(requirements[i], 'images[0].url', '');
      }
    }
    currentPropertyDetail['coverUrl'] = coverUrl;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.UPDATE_EMAIL_IN_PROPERTY_DETAILS]: (state, action) => {
    const { email, propertyId, is_another_user_present } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[propertyId] || {};
    if (!is_another_user_present) {
      set(currentPropertyDetail, 'kycDetails.personal_details.email_address', email);
      set(currentPropertyDetail, 'kycDetails.personal_details.is_another_user_present', is_another_user_present);
    }

    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [propertyId]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.REMOVE_INACTIVE_IMAGES]: (state, action) => {
    const { propertyDetailsMap } = state;
    const { property_unique_id } = action.payload;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const imagesConfig = get(currentPropertyDetail, 'imagesConfig', {});
    let images = cloneDeep(get(imagesConfig, 'allImages', []));

    for (let i = 0; i < images.length; i++) {
      if (images[i].isUploading) {
        images[i] = {
          ...images[i],
          is_active: false
        };
      }
    }

    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          imagesConfig: {
            ...imagesConfig,
            allImages: images
          }
        }
      }
    };
  },
  [actionTypes.ON_IMAGE_UPLOAD_FAILURE]: (state, action) => {
    const { propertyDetailsMap } = state;
    const { property_unique_id, imageFile } = action.payload;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const imagesConfig = get(currentPropertyDetail, 'imagesConfig', {});
    let images = cloneDeep(get(imagesConfig, 'allImages', []));

    for (let i = 0; i < images.length; i++) {
      if (get(imageFile, 'fileId', null) === get(images[i], 'id')) {
        images[i] = { ...images[i], is_active: false };
        break;
      }
    }

    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          imagesConfig: {
            ...imagesConfig,
            allImages: images
          }
        }
      }
    };
  },
  [actionTypes.ON_IMAGE_UPLOAD_SUCCESS]: (state, action) => {
    const { propertyDetailsMap } = state;
    const { property_unique_id, imageFile, uploadUrlData, tag } = action.payload;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const imagesConfig = get(currentPropertyDetail, 'imagesConfig', {});
    let images = cloneDeep(get(imagesConfig, 'allImages', []));
    for (let i = 0; i < images.length; i++) {
      if (get(imageFile, 'fileId', null) === get(images[i], 'id')) {
        images[i] = {
          ...images[i],
          id: get(uploadUrlData, 'image_id', get(images[i], 'id')),
          isUploading: false,
          isCategorising: false,
          isInBackground: false,
          tag: tag
        };
        break;
      }
    }

    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail,
          imagesConfig: {
            ...imagesConfig,
            allImages: images
          }
        }
      }
    };
  },
  [actionTypes.UPDATE_IMAGE_PERCENTILE]: (state, action) => {
    const { propertyDetailsMap } = state;
    const { property_unique_id, imageFile, progressEventData } = action.payload;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    const imagesConfig = get(currentPropertyDetail, 'imagesConfig', {});

    const { needToUpdateStore = false, updatedImages } = updateImageDataOnPercentileChange({
      payload: { imageFile, progressEventData },
      images: get(imagesConfig, 'allImages', [])
    });

    if (needToUpdateStore) {
      return {
        ...state,
        propertyDetailsMap: {
          ...propertyDetailsMap,
          [property_unique_id]: {
            ...currentPropertyDetail,
            imagesConfig: {
              ...imagesConfig,
              allImages: [...updatedImages]
            }
          }
        }
      };
    } else {
      return state;
    }
  },
  [actionTypes.FETCH_KYC_WIDGET_DATA_SUCCESS]: (state, action) => {
    const { data, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['kycWidgetData'] = get(data, 'widget_list', []);
    currentPropertyDetail['isKycWidgetDataLoading'] = false;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_TERMS_OF_SERVICE_WIDGET_SUCCESS]: (state, action) => {
    const { data, property_unique_id } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['termsOfServiceWidgetData'] = get(data, 'widget_list[0].contents.data', {});
    currentPropertyDetail['isTermsOfServiceWidgetDataLoading'] = false;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_KYC_WIDGET_DATA]: (state, action) => {
    const { property_unique_id, isLoading } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['kycWidgetData'] = [];
    currentPropertyDetail['isKycWidgetDataLoading'] = isLoading;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.START_FETCHING_TERMS_OF_SERVICE_WIDGET]: (state, action) => {
    const { property_unique_id, isLoading } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['termsOfServiceWidgetData'] = {};
    currentPropertyDetail['isTermsOfServiceWidgetDataLoading'] = isLoading;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_KYC_WIDGET_DATA_FAILED]: (state, action) => {
    const { property_unique_id, isLoading } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['kycWidgetData'] = [];
    currentPropertyDetail['isKycWidgetDataLoading'] = isLoading;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.FETCH_TERMS_OF_SERVICE_WIDGET_FAILED]: (state, action) => {
    const { property_unique_id, isLoading } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['termsOfServiceWidgetData'] = {};
    currentPropertyDetail['isTermsOfServiceWidgetDataLoading'] = isLoading;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  },
  [actionTypes.UPDATE_REFERRAL_DETAILS]: (state, action) => {
    const { property_unique_id, data } = action.payload;
    const { propertyDetailsMap } = state;
    const currentPropertyDetail = propertyDetailsMap[property_unique_id] || {};
    currentPropertyDetail['referralDetails'] = data;
    return {
      ...state,
      propertyDetailsMap: {
        ...propertyDetailsMap,
        [property_unique_id]: {
          ...currentPropertyDetail
        }
      }
    };
  }
};

export default createReducer(INITIAL_STATE, reducer);
